import { Product } from "interfaces";
import ProductList from "containers/productList/productList";
import { useTranslation } from "react-i18next";
import cls from "./liked.module.scss";
import Loading from "components/loader/loading";
import Empty from "components/empty/empty";
import LoadMore from "components/button/load-more";
import React from "react";

type Props = {
  data: Product[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  fetchingNextPage?: () => void;
};

export default function LikedProducts({
  data,
  isLoading = false,
  hasNextPage = false,
  isFetchingNextPage = false,
  fetchingNextPage,
}: Props) {
  const { t } = useTranslation();
  const renderView = () => {
    if (!data?.length) {
      return <Empty text={t("no.liked.products")} />;
    }
    return <ProductList products={data} />;
  };
  const handleLoadNexPage = () => {
    if (hasNextPage && fetchingNextPage) {
      fetchingNextPage();
    }
  };
  return (
    <>
      <h1 className={cls.title}>{t("liked.products")}</h1>
      {isLoading && <Loading />}
      {renderView()}
      {hasNextPage && (
        <LoadMore loading={isFetchingNextPage} onClick={handleLoadNexPage}>
          {t("load.more")}
        </LoadMore>
      )}
    </>
  );
}
